import { toRefs, provide, computed } from 'vue';
import Paper from '../paper/component-lib.esm.js';
import { PaperProps } from '../paper/component-lib.esm2.js';
import { useTheme } from '../../compositions/component-lib.esm3.js';
import { getThemeColor } from '../../styles/theme/component-lib.esm.js';

//
var script = {
  name: 'Card',
  components: {
    Paper
  },
  props: {
    ...PaperProps,
    borderWidth: {
      type: [Number, String],
      default: 1
    },
    elevation: {
      type: Number,
      default: 1
    },
    hideStaticShadow: {
      type: Boolean,
      default: true
    },
    /** `left` | `right` | `center` */
    align: {
      type: String,
      default: 'left'
    }
  },
  setup(props) {
    const {
      color,
      borderColor,
      align
    } = toRefs(props);
    const theme = useTheme();
    provide('cardAlign', align);
    const styles = computed(() => {
      return {
        '--c-color': getThemeColor(color.value, theme.value),
        '--c-border-color': getThemeColor(borderColor.value, theme.value),
        '--c-text-align': align.value
      };
    });
    return {
      styles
    };
  }
};
export { script as default };